import { render, staticRenderFns } from "./StudentTable.vue?vue&type=template&id=3042df2b&scoped=true&"
import script from "./StudentTable.vue?vue&type=script&lang=ts&"
export * from "./StudentTable.vue?vue&type=script&lang=ts&"
import style0 from "./StudentTable.vue?vue&type=style&index=0&id=3042df2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042df2b",
  null
  
)

export default component.exports